import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HomePageStyle.css";

/* ─── ICONS ─── */
const CheckIcon = () => (
  <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const PlayIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polygon points="10 8 16 12 10 16 10 8" fill="currentColor" stroke="none" />
  </svg>
);

const WAIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 1.77.46 3.43 1.27 4.88L2 22l5.12-1.27A9.952 9.952 0 0012 22z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

const OutreachIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

const SolvMateCoreIcon = () => (
  <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 1.8.48 3.5 1.3 5L2 22l5-1.3c1.5.82 3.2 1.3 5 1.3z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

function OrbitalChannelDiagram() {
  return (
    <div className="orbital-container">
      <div className="orbital-wrapper">
        <div className="orbital-glow central-glow"></div>
        <div className="orbital-ring inner-ring"></div>
        <div className="orbital-ring outer-ring"></div>
        <div className="core-node">
          <div className="core-pulse-1"></div>
          <div className="core-pulse-2"></div>
          <div className="core-icon-wrap">
            <SolvMateCoreIcon />
          </div>
          <span className="core-label">Blastmate AI Core</span>
        </div>
        <div className="channel-node whatsapp-node float-anim-1">
          <div className="channel-icon-wrap bg-whatsapp">
            <WhatsAppIcon />
          </div>
          <span className="channel-label">WhatsApp</span>
        </div>
        <div className="channel-node linkedin-node float-anim-2">
          <div className="channel-icon-wrap bg-linkedin">
            <LinkedInIcon />
          </div>
          <span className="channel-label">LinkedIn</span>
        </div>
        <div className="channel-node instagram-node float-anim-3">
          <div className="channel-icon-wrap bg-instagram">
            <InstagramIcon />
          </div>
          <span className="channel-label">Instagram</span>
        </div>
        <div className="channel-node outreach-node float-anim-4">
          <div className="channel-icon-wrap bg-outreach">
            <OutreachIcon />
          </div>
          <span className="channel-label">Outreach</span>
        </div>
        <svg className="orbital-svg-lines" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="line-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="var(--b600)" stopOpacity="0.8" />
              <stop offset="100%" stopColor="var(--b300)" stopOpacity="0.2" />
            </linearGradient>
          </defs>
          <path d="M 200 50 Q 200 120 200 200" fill="none" stroke="url(#line-grad)" strokeWidth="2.5" strokeDasharray="6,6" className="flow-dash" />
          <path d="M 350 200 Q 270 200 200 200" fill="none" stroke="url(#line-grad)" strokeWidth="2.5" strokeDasharray="6,6" className="flow-dash" />
          <path d="M 200 350 Q 200 280 200 200" fill="none" stroke="url(#line-grad)" strokeWidth="2.5" strokeDasharray="6,6" className="flow-dash" />
          <path d="M 50 200 Q 130 200 200 200" fill="none" stroke="url(#line-grad)" strokeWidth="2.5" strokeDasharray="6,6" className="flow-dash" />
        </svg>
      </div>
    </div>
  );
}

/* ─── SCROLL REVEAL HOOK ─── */
function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal, .reveal-left, .reveal-right");
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("up"); }),
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

/* ─── NAVBAR ─── */
function Navbar() {
  const navigate = useNavigate();
  return (
    <nav className="nav">
      <div className="nav-wrap">
        <a className="logo" href="#">
          <img src="/logo.png" alt="Blastmate Logo" />
          Blastmate
        </a>
        <ul className="nav-links">
          <li><a href="#features">Features</a></li>
          <li><a href="#how">How it Works</a></li>
          <li><a href="#faq">FAQ</a></li>
        </ul>
        <div className="nav-actions">
          <button className="btn-login" onClick={() => navigate("/login")}>Login</button>
          <button className="btn-start" onClick={() => navigate("/signup")}>Start for Free →</button>
        </div>
      </div>
    </nav>
  );
}

/* ─── HERO ─── */
function Hero() {
  const navigate = useNavigate();
  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="hero-text">
          <div className="hero-badge reveal">
            <span style={{ color: "var(--green)", fontSize: "1rem" }}>●</span>
            Blastmate Multichannel Automation Engine
          </div>
          <h1 className="reveal delay-1">
            Omnichannel Automation<br />
            <span>Built for Hyper-Growth</span>
          </h1>
          <p className="hero-sub reveal delay-2">
            Connect all your customer channels — WhatsApp, LinkedIn, Instagram, and Outreach — to Blastmate's unified AI core. Automate conversations, capture leads, and scale outreach instantly.
          </p>
          <div className="hero-cta reveal delay-3">
            <button className="btn-hero" onClick={() => navigate("/signup")}>Get Started Free <ArrowIcon /></button>
          </div>
          <div className="hero-trust reveal delay-4">
            {["No credit card", "Meta Verified", "24/7 Support"].map((t) => (
              <div className="trust-tag" key={t}>
                <div className="trust-check"><CheckIcon /></div>
                {t}
              </div>
            ))}
          </div>
        </div>

        <div className="hero-img reveal-right">
          <OrbitalChannelDiagram />
          <div className="hero-float-card card1">
            <div>
              <div className="float-num">98%</div>
              <div className="float-label">Message<br />Open Rate</div>
            </div>
            <div style={{ marginLeft: 8, display: "flex", alignItems: "center", gap: 6 }}>
              <div className="float-dot"></div>
              <span style={{ fontSize: ".78rem", color: "var(--g600)", fontWeight: 600 }}>Live</span>
            </div>
          </div>
          <div className="hero-float-card card2">
            <div>
              <div className="float-num">500+</div>
              <div className="float-label">Businesses<br />Onboarded</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─── STATS ─── */
function Stats() {
  const items = [
    { n: "10+", l: "Years Exp" },
    { n: "4", l: "Channels" },
    { n: "Global", l: "Reach" },
    { n: "98%", l: "Average open rate" },
    { n: "10M+", l: "Messages delivered" },
    { n: "3×", l: "Lead conversion boost" },
  ];
  return (
    <div className="stats">
      <div className="stats-wrap">
        {items.map((s, i) => (
          <div className={`stat reveal${i ? ` delay-${i}` : ""}`} key={s.n}>
            <div className="stat-n">{s.n}</div>
            <div className="stat-l">{s.l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ─── FEATURE SPLIT (reusable) ─── */
function FeatureSplit({ tag, title, desc, checks, btnLabel, img, imgBadge, flip, bg }) {
  return (
    <section className={`sec${bg ? " feat-bg" : ""}`}>
      <div className="sec-inner">
        <div className={`split${flip ? " flip" : ""}`}>
          <div className={`split-img ${flip ? "reveal-right" : "reveal-left"}`}>
            <img src={img} alt={tag} loading="lazy" />
            <div className="split-img-badge">{imgBadge}</div>
          </div>
          <div className={`split-content ${flip ? "reveal-left" : "reveal-right"}`}>
            <span className="sec-tag">{tag}</span>
            <h2 className="sec-h" dangerouslySetInnerHTML={{ __html: title }} />
            <p className="sec-p">{desc}</p>
            <ul className="check-list">
              {checks.map((c) => (
                <li className="check-item" key={c}>
                  <div className="check-icon"><CheckIcon /></div>
                  {c}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─── FEATURES GRID ─── */
function FeaturesGrid() {
  const cards = [
    {
      img: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=80&fit=crop",
      title: "Centralized Shared Inbox",
      desc: "Manage all customer conversations from one dashboard. Assign, track, and collaborate — your whole team, one number.",
    },
    {
      img: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=600&q=80&fit=crop",
      title: "AI-Powered Chatbots",
      desc: "Deploy intelligent agents that handle FAQs, capture leads, and book appointments — day and night, no coding needed.",
    },
    {
      img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=80&fit=crop",
      title: "Real-time Analytics",
      desc: "Track agent performance, campaign ROI, and customer journeys. Make decisions backed by live data.",
    },
    {
      img: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&q=80&fit=crop",
      title: "Deep Integrations",
      desc: "Connect Shopify, Razorpay, Zoho, HubSpot and 30+ tools. Trigger WhatsApp messages from any event automatically.",
    },
    {
      img: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=600&q=80&fit=crop",
      title: "WhatsApp Broadcasts",
      desc: "Send bulk campaigns with Meta-approved templates. Personalize every message and track results in real time.",
    },
    {
      img: "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=600&q=80&fit=crop",
      title: "Click-to-WhatsApp Ads",
      desc: "Convert ad clicks into WhatsApp conversations instantly. Capture leads before they bounce.",
    },
  ];

  return (
    <section className="sec feat-bg" id="features">
      <div className="sec-inner">
        <div className="tc reveal">
          <span className="sec-tag">Everything You Need</span>
          <h2 className="sec-h">Built for performance at every scale</h2>
          <p className="sec-p">Six powerful capabilities. One unified platform.</p>
        </div>
        <div className="feat-grid">
          {cards.map((c, i) => (
            <div className={`feat-card reveal delay-${(i % 3) + 1}`} key={c.title}>
              <img className="feat-img" src={c.img} alt={c.title} loading="lazy" />
              <div className="feat-body">
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── HOW IT WORKS ─── */
function HowItWorks() {
  const steps = [
    { num: "1", title: "Discovery", desc: "We analyze your audience touchpoints, existing outreach channels, and integration needs to uncover hidden friction." },
    { num: "2", title: "Rhythm Mapping", desc: "We formulate your Audience Rhythm Map™ targeting ideal time frames, message frequencies, and custom tones." },
    { num: "3", title: "Build", desc: "Our engineers configure your Blastmate AI core, set up omnichannel bridges, and integrate legacy CRM databases." },
    { num: "4", title: "Launch", desc: "We activate the system, monitor active flow data, and dynamically adjust timing models for maximum conversions." },
  ];

  return (
    <section className="sec how-bg" id="how">
      <div className="sec-inner">
        <div className="tc reveal">
          <span className="sec-tag">4-Step Process</span>
          <h2 className="sec-h">Our Delivery Methodology</h2>
          <p className="sec-p">From friction analysis to scaled automation in four structured phases.</p>
        </div>
        <div className="steps">
          {steps.map((s, i) => (
            <div className={`step reveal delay-${i + 1}`} key={s.num}>
              <div className="step-circle">
                <span className="step-num-inner">{s.num}</span>
              </div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── INDUSTRIES ─── */
function Industries() {
  const industries = [
    { img: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&q=80&fit=crop", title: "E-Commerce & Retail", desc: "Order updates, abandoned cart recovery, and post-purchase support." },
    { img: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=600&q=80&fit=crop", title: "Healthcare & Clinics", desc: "Appointment booking, reminders, and patient FAQs — automated." },
    { img: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=600&q=80&fit=crop", title: "Education & Ed-Tech", desc: "Enrolment flows, class reminders, and fee collection on WhatsApp." },
    { img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80&fit=crop", title: "Real Estate", desc: "Qualify buyers, schedule site visits, and send property updates." },
    { img: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=600&q=80&fit=crop", title: "Food & Restaurants", desc: "Menu sharing, reservations, and delivery tracking via WhatsApp." },
    { img: "https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=600&q=80&fit=crop", title: "Finance & Banking", desc: "Loan eligibility checks, EMI alerts, and statement requests." },
  ];

  return (
    <section className="sec" id="industries">
      <div className="sec-inner">
        <div className="tc reveal">
          <span className="sec-tag">Industries</span>
          <h2 className="sec-h">Built for every business vertical</h2>
          <p className="sec-p">Blastmate powers growth across all major Indian industries.</p>
        </div>
        <div className="ind-grid">
          {industries.map((ind, i) => (
            <div className={`ind-card reveal delay-${(i % 3) + 1}`} key={ind.title}>
              <img src={ind.img} alt={ind.title} loading="lazy" />
              <div className="ind-overlay">
                <h4>{ind.title}</h4>
                <p>{ind.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── TESTIMONIALS ─── */
function TestAvatar({ name, src }) {
  const [error, setError] = useState(false);
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  const colors = [
    ["#3b82f6", "#1d4ed8"], // Blue
    ["#10b981", "#047857"], // Green
    ["#8b5cf6", "#6d28d9"], // Purple
    ["#ec4899", "#be185d"], // Pink
    ["#f59e0b", "#b45309"], // Amber
    ["#ef4444", "#b91c1c"], // Red
  ];
  const colorIdx = name.length % colors.length;
  const [c1, c2] = colors[colorIdx];

  if (src && !error) {
    return (
      <img
        className="test-avatar"
        src={src}
        alt={name}
        onError={() => setError(true)}
      />
    );
  }

  return (
    <div
      className="test-avatar"
      style={{
        background: `linear-gradient(135deg, ${c1}, ${c2})`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: "700",
        fontSize: "0.85rem",
        letterSpacing: "0.03em",
      }}
    >
      {initials}
    </div>
  );
}

  
/* ─── FAQ ─── */
function FAQ() {
  const faqs = [
    {
      q: "Is Blastmate an official WhatsApp Business API provider?",
      a: "Yes. Blastmate is an official Meta Business Solution Provider (BSP). Your messages are sent through Meta's verified infrastructure, ensuring 100% compliance and zero risk of account bans.",
    },
    {
      q: "How long does it take to get started?",
      a: "Most businesses are live within 30 minutes. You connect your WhatsApp Business number, set up your first flow using our drag-and-drop builder, and start sending — no developers required.",
    },
    {
      q: "Can I use my existing WhatsApp Business number?",
      a: "Yes, you can port your existing WhatsApp Business number to Blastmate. The porting process typically takes 24–48 hours.",
    },
    {
      q: "What languages does the AI chatbot support?",
      a: "The AI supports English, Hindi, Tamil, Telugu, Kannada, Malayalam, Bengali, Marathi, and Gujarati — covering all major Indian languages. More are being added continuously.",
    },
    {
      q: "Is there a limit on the number of messages I can send?",
      a: "Message limits depend on your Meta Business Account tier. New accounts start at 1,000 conversations/day and scale automatically as you build a quality send history. Blastmate helps you grow your tier faster.",
    },
    {
      q: "Do you offer a free trial?",
      a: "Yes! You can start for free with no credit card required. Our free plan includes up to 1,000 conversations so you can experience the platform before committing to a paid plan.",
    },
  ];

  const [open, setOpen] = useState(null);

  return (
    <section className="sec" id="faq">
      <div className="sec-inner">
        <div className="tc reveal">
          <span className="sec-tag">FAQ</span>
          <h2 className="sec-h">Questions? We've got answers.</h2>
          <p className="sec-p">Everything you need to know about Blastmate.</p>
        </div>
        <div className="faq-list">
          {faqs.map((f, i) => (
            <div className={`faq-item${open === i ? " open" : ""}`} key={i}>
              <div className="faq-q" onClick={() => setOpen(open === i ? null : i)}>
                {f.q}
                <button className="faq-tog">+</button>
              </div>
              <div className="faq-a">
                <div className="faq-a-inner">{f.a}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}




/* ─── FOOTER ─── */
function Footer() {
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="logo" style={{ color: "#fff" }}>
              <div className="logo-mark"><WAIcon /></div>
              Blastmate
            </div>
            <p>The smartest WhatsApp marketing platform for Indian businesses. Official Meta BSP. Trusted by 500+ brands.</p>
          </div>
          <div className="footer-col">
            <h5>Product</h5>
            <ul>
              <li>Shared Inbox</li>
              <li>AI Chatbots</li>
              <li>Broadcasts</li>
              <li>Analytics</li>
              <li>Integrations</li>
              <li>Click-to-WhatsApp</li>
            </ul>
          </div>
          <div className="footer-col">
            <h5>Company</h5>
            <ul>
              <li>About Us</li>
              <li>Careers</li>
              <li>Blog</li>
              <li>Case Studies</li>
              <li>Partners</li>
            </ul>
          </div>
          <div className="footer-col">
            <h5>Support</h5>
            <ul>
              <li>Help Center</li>
              <li>API Docs</li>
              <li>Status Page</li>
              <li><a href="mailto:hello@solvmate.in">Contact Us</a></li>
              <li>Community</li>
            </ul>
          </div>
        </div>
        <div className="footer-bot">
          <p>© 2024 Blastmate Technologies Pvt. Ltd. All rights reserved.</p>
          <p className="footer-powered">
            Powered by SolvMate.in
          </p>
          <div className="footer-links">
            <span>Privacy Policy</span>
            <span>Terms of Service</span>
            <span>Cookie Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ─── LIVE CHAT MOCKUP ─── */
function LiveChatMockup() {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    let active = true;
    const conversation = [
      { text: "Hey! Can I automate my customer support?", isUser: true, delay: 1000 },
      { text: "Absolutely!  Blastmate AI handles 80% of FAQs automatically.", isUser: false, delay: 2000 },
      { text: "Will it work in Hindi & Tamil?", isUser: true, delay: 1800 },
      { text: "Yes! 🇮🇳 I support Hindi, Tamil, Telugu, and 8+ major languages.", isUser: false, delay: 2200 },
      { text: "Awesome, how do I get started?", isUser: true, delay: 1800 },
      { text: "Click the button below to start your free 14-day trial! ", isUser: false, delay: 2200, hasButton: true }
    ];

    const runConversation = async () => {
      if (!active) return;
      setMessages([]);
      setIsTyping(false);

      for (let step of conversation) {
        if (!active) return;

        await new Promise(r => setTimeout(r, 600));
        if (!active) return;

        if (!step.isUser) {
          setIsTyping(true);
          await new Promise(r => setTimeout(r, 1200));
          if (!active) return;
          setIsTyping(false);
        }

        setMessages(prev => [...prev, step]);
        await new Promise(r => setTimeout(r, step.delay));
      }

      await new Promise(r => setTimeout(r, 4000));
      if (active) {
        runConversation();
      }
    };

    runConversation();

    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="wa-mockup-device">
      <div className="wa-mockup-header">
        <div className="wa-header-info">
          <div className="wa-header-name">Blastmate Assistant</div>
          <div className="wa-header-status">
            <span className="wa-status-dot"></span> Online
          </div>
        </div>
      </div>
      <div className="wa-mockup-body">
        {messages.map((m, idx) => (
          <div key={idx} className={`wa-bubble-wrap ${m.isUser ? "user" : "bot"}`}>
            <div className="wa-bubble">
              <p>{m.text}</p>
              <span className="wa-time">
                {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
            {m.hasButton && (
              <button className="wa-quick-reply-pill" onClick={() => navigate("/signup")}>
                Start Free Trial
              </button>
            )}
          </div>
        ))}
        {isTyping && (
          <div className="wa-bubble-wrap bot">
            <div className="wa-bubble wa-typing-bubble">
              <div className="typing-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ─── SERVICES ─── */
function Services() {
  return (
    <section className="sec services-section" id="services">
      <div className="sec-inner">
        <div className="tc reveal">
          <span className="sec-tag">Omnichannel Verticals</span>
          <h2 className="sec-h">Powering Every Outreach Channel</h2>
          <p className="sec-p">Four standard-setting channel suites, engineered to capture leads and close sales automatically.</p>
        </div>

        <div className="services-bento">
          {/* Featured WhatsApp Bento Card */}
          <div className="bento-card bento-featured reveal">
            <div>
              <span className="sec-tag" style={{ background: "rgba(37, 211, 102, 0.15)", color: "#25D366" }}>Featured Vertical</span>
              <h3>WhatsApp Automation Suite</h3>
              <p>
                The ultimate customer engagement engine for Indian SMBs. Run broadcast marketing, deploy intelligent AI customer agents, and connect your entire support team to a single official Meta API number.
              </p>
              <ul className="feat-list">
                <li className="feat-item"><CheckIcon /> 100% Meta Compliant — Zero Ban Risk</li>
                <li className="feat-item"><CheckIcon /> 98% Message Open Rate Campaigns</li>
                <li className="feat-item"><CheckIcon /> Automated Abandoned Cart Recovery</li>
                <li className="feat-item"><CheckIcon /> Multilingual Chatbots (Hindi, Tamil, etc.)</li>
              </ul>
            </div>
            <div className="wa-mockup-wrapper">
              <LiveChatMockup />
            </div>
          </div>

          {/* LinkedIn Automator */}
          <div className="bento-card reveal delay-1">
            <div className="bento-card-icon bg-linkedin-icon">
              <LinkedInIcon />
            </div>
            <h3>LinkedIn Growth</h3>
            <p>
              Automate B2B lead generation. Deploy smart, hyper-personalized sequences that connect, interact, and send follow-ups while staying fully safe.
            </p>
            <div className="bento-card-visual">
              <div className="bento-linkedin-visual">
                <div className="linkedin-item">
                  <span>Connection Request</span>
                  <span className="linkedin-status status-sent">Sent</span>
                </div>
                <div className="linkedin-item">
                  <span>Intro Sequence</span>
                  <span className="linkedin-status status-replied">Replied (3m ago)</span>
                </div>
              </div>
            </div>
          </div>

          {/* Instagram DM Engine */}
          <div className="bento-card reveal delay-2">
            <div className="bento-card-icon bg-instagram-icon">
              <InstagramIcon />
            </div>
            <h3>Instagram DM Engine</h3>
            <p>
              Convert comments and stories into DMs instantly. Reply automatically to story mentions, send instant custom links, and close leads on the spot.
            </p>
            <div className="bento-card-visual">
              <div className="bento-instagram-visual">
                <div className="insta-bubble">Comment 'Grow'</div>
                <div className="insta-bubble accent">DM Triggered!</div>
              </div>
            </div>
          </div>

          {/* Outreach & Email Suite */}
          <div className="bento-card reveal delay-3">
            <div className="bento-card-icon bg-outreach-icon">
              <OutreachIcon />
            </div>
            <h3>Cold Outreach</h3>
            <p>
              Combine cold email, SMS, and WhatsApp into unified cross-channel workflows. Never drop a lead with auto-replies and shared customer context.
            </p>
            <div className="bento-card-visual">
              <div className="bento-outreach-visual">
                <div className="outreach-badge"> Cold Email Sent</div>
                <div className="outreach-badge"> Auto-Followup</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─── AUDIENCE RHYTHM CHART ─── */
function AudienceRhythmChart() {
  const [data, setData] = useState([25, 45, 90, 65, 80, 35]);

  useEffect(() => {
    let active = true;
    const updateData = () => {
      if (!active) return;
      setData(prev =>
        prev.map(val => {
          const change = Math.floor(Math.random() * 15) - 7;
          const nextVal = val + change;
          return Math.max(15, Math.min(100, nextVal));
        })
      );
      setTimeout(updateData, 3000);
    };

    setTimeout(updateData, 3000);
    return () => {
      active = false;
    };
  }, []);

  const hours = ["9 AM", "12 PM", "3 PM", "6 PM", "9 PM", "12 AM"];

  return (
    <div className="rhythm-card">
      <div className="rhythm-card-header">
        <div>
          <div className="rhythm-tag">LIVE ENGINE</div>
          <h4 className="rhythm-title">Audience Rhythm Map™</h4>
        </div>
        <div className="rhythm-pulse-badge">
          <span className="pulse-dot-green"></span> Scanning
        </div>
      </div>

      <div className="rhythm-chart-container">
        {data.map((val, idx) => (
          <div key={idx} className="rhythm-bar-col">
            <div className="rhythm-bar-track">
              <div
                className={`rhythm-bar-fill ${val > 80 ? 'peak' : ''}`}
                style={{ height: `${val}%`, transition: 'height 1s cubic-bezier(0.16, 1, 0.3, 1)' }}
              >
                {val > 80 && <span className="rhythm-bar-badge">Peak</span>}
              </div>
            </div>
            <span className="rhythm-bar-label">{hours[idx]}</span>
          </div>
        ))}
      </div>

      <div className="rhythm-footer">
        <div className="rhythm-stat">
          <div className="rhythm-stat-val">74.2%</div>
          <div className="rhythm-stat-lbl">Optimum Reach Score</div>
        </div>
        <div className="rhythm-divider"></div>
        <div className="rhythm-stat">
          <div className="rhythm-stat-val">3 PM</div>
          <div className="rhythm-stat-lbl">Best Window Today</div>
        </div>
      </div>
    </div>
  );
}

/* ─── OUR EDGE ─── */
function OurEdge() {
  return (
    <section className="sec edge-section" id="edge">
      <div className="sec-inner">
        <div className="edge-grid">
          <div className="edge-content reveal-left">
            <span className="sec-tag">Why Blastmate</span>
            <h2 className="sec-h">Engineering Your Conversational Edge</h2>
            <p className="sec-p">
              We don't just build chatbots. We map customer behavior, narrative positioning, and timings to engineer frictionless conversion loops.
            </p>

            <div className="edge-pillars">
              <div className="edge-pillar">
                <div className="edge-pillar-body">
                  <h4>Rhythm Intelligence</h4>
                  <p>Our algorithms track live user interactions to dispatch follow-ups exactly when conversion probability is at its peak. Zero spam, maximum response.</p>
                </div>
              </div>

              <div className="edge-pillar">
                <div className="edge-pillar-body">
                  <h4>Storytelling Positioning</h4>
                  <p>We replace dry scripts with psychological storytelling frameworks. Your messages feel like a warm, personalized chat from a trusted partner.</p>
                </div>
              </div>

              <div className="edge-pillar">
                <div className="edge-pillar-body">
                  <h4>International Experience</h4>
                  <p>Leveraging a decade of global campaign execution, our structures guarantee highest delivery standards, meta compliances, and top opt-in ratios.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="edge-visual-wrap reveal-right">
            <AudienceRhythmChart />
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─── APP ─── */
export default function App() {
  useReveal();

  return (
    <>
      <Navbar />
      <Hero />
      <Stats />
      <Services />
      <OurEdge />

      {/* Feature Split 1 — Shared Inbox */}
      <FeatureSplit
        tag="Shared Inbox"
        title="One inbox.<br/>Your whole team."
        desc="Stop losing leads across personal phones. Every WhatsApp conversation lands in one place — assign, track, and reply as a team, even when someone's offline."
        checks={[
          "Assign chats to specific agents in one click",
          "See real-time typing and online status of team",
          "Add internal notes visible only to agents",
          "Unlimited agents on one WhatsApp number",
        ]}
        btnLabel="Explore Inbox"
        img="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=700&q=80&fit=crop"
        imgBadge={
          <>
            <div style={{ width: 10, height: 10, borderRadius: "50%", background: "var(--green)", animation: "pulse 2s infinite" }} />
            Team inbox — live
          </>
        }
        flip={false}
        bg={false}
      />

      {/* Feature Split 2 — AI Automation */}
      <FeatureSplit
        tag="AI Automation"
        title="AI that works<br/>while you sleep."
        desc="Deploy an AI agent that handles FAQs, qualifies leads, and books appointments — 24/7, in any language. Your team only steps in when it truly matters."
        checks={[
          "No-code drag-and-drop flow builder",
          "Multilingual support — Hindi, Tamil & more",
          "Human handoff when AI reaches its limits",
          "Live in under 10 minutes — no developers",
        ]}
        btnLabel="See AI in Action"
        img="https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=700&q=80&fit=crop"
        imgBadge={
          <>
            <div style={{ width: 10, height: 10, borderRadius: "50%", background: "var(--green)", animation: "pulse 2s infinite" }} />
            AI Agent — live
          </>
        }
        flip={true}
        bg={true}
      />

      {/* Feature Split 3 — Broadcasting */}
      <FeatureSplit
        tag="Broadcasting"
        title="Send to thousands.<br/>Feel like one-on-one."
        desc="Run targeted broadcast campaigns using Meta-approved templates. Personalize at scale, track every click, and retarget customers who didn't convert."
        checks={[
          "Personalized variables in every message",
          "Segment audiences by behavior and tags",
          "Track opens, replies, and link clicks live",
          "100% Meta-compliant — zero ban risk",
        ]}
        btnLabel="Explore Broadcasts"
        img="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=700&q=80&fit=crop"
        imgBadge={
          <>
            <div style={{ width: 10, height: 10, borderRadius: "50%", background: "var(--green)", animation: "pulse 2s infinite" }} />
            98% open rate
          </>
        }
        flip={false}
        bg={false}
      />

      <FeaturesGrid />
      <HowItWorks />
      <FAQ />
      <Footer />
    </>
  );
}
